/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ValidateResourceConfigurationRequest {
  /**
  * Eon cloud resource ID of the resource to validate
  */
  'resourceId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceId",
      "baseName": "resourceId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ValidateResourceConfigurationRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

